import { useState } from "react";
import PropTypes from "prop-types";
import useNotification from "../../hooks/useNotification";

const UploadSignedPaper = ({ setBase64File }) => {
  const [fileName, setFileName] = useState("");
  const { errorToast } = useNotification();

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const [, base64Data] = reader.result.split(",");
        resolve(base64Data);
      };
      reader.onerror = () => {
        const error = new Error("Error converting file to base64");
        reject(error);
      };
    });
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const acceptedTypes = ["image/jpeg", "image/png", "image/webp"];
    if (!acceptedTypes.includes(file.type)) {
      errorToast("Please upload a JPEG, PNG, or WEBP image.");
      event.target.value = "";
      return;
    }

    try {
      const base64String = await convertToBase64(file);
      setFileName(file.name);
      setBase64File?.(base64String);
    } catch (error) {
      console.error("File conversion failed:", error);
    }
  };

  const removeFile = () => {
    setFileName("");
    setBase64File?.(null);
  };

  return (
    <div>
      <label
        style={{
          display: "block",
          marginBottom: "8px",
          fontWeight: 600,
          fontSize: "14px",
        }}
        htmlFor="consent-upload"
      >
        Add a photo of the signed Consent form
      </label>

      {fileName ? (
        <div
          style={{
            width: "fit-content",
            padding: "8px 12px",
            border: "1px solid var(--theme-btn-primary-border, #9BABB4)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 50,
          }}
        >
          <span
            style={{
              fontWeight: 700,
              fontStyle: "bold",
              fontSize: 14,
              color: "var(--theme-text,#051923)",
            }}
          >
            {fileName}
          </span>

          <button
            type="button"
            onClick={removeFile}
            style={{
              border: "none",
              background: "transparent",
              color: "var(--theme-danger, #e53935)",
              cursor: "pointer",
              fontSize: "16px",
            }}
          >
            ✕
          </button>
        </div>
      ) : (
        <>
          <input
            id="consent-upload"
            name="consent-upload"
            type="file"
            accept="image/jpeg,image/png,image/webp"
            onChange={handleFileUpload}
            hidden
            style={{ width: 200 }}
          />
          <label
            htmlFor="consent-upload"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              padding: "10px 20px",
              border: "2px solid var(--theme-btn-primary-border, #23668C)",
              color: "var(--theme-accent, #23668C)",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: 700,
            }}
          >
            <img src="/ui/images/Truman-UI-Icon-Upload.svg" alt="Upload" />
            <span>UPLOAD IMAGE</span>
          </label>
        </>
      )}
    </div>
  );
};

export default UploadSignedPaper;

UploadSignedPaper.propTypes = {
  setBase64File: PropTypes.func,
};
